export class FileAllegato {
  name:string;
  source:string;
  thumbnailSource:string;
  alt:string;
  titolo:string;

}
